var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176.793,
    height: 37.884,
    viewBox: "0 0 176.793 37.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11155",
    "data-name": "Group 11155",
    transform: "translate(-76.026 -49.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10825",
    "data-name": "Group 10825",
    transform: "translate(76.026 49.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4464",
    "data-name": "Path 4464",
    d: "M241.888,168.616H227.343a2.961,2.961,0,0,1-2.931-2.989V143.658a2.932,2.932,0,1,1,5.862,0v18.979h11.614a2.99,2.99,0,0,1,0,5.979M125.1,168.141a3.026,3.026,0,0,0,.879-4.132l-13.85-21.968a2.9,2.9,0,0,0-4.929,0l-13.85,21.968a3.025,3.025,0,0,0,.879,4.132,2.894,2.894,0,0,0,4.05-.9l11.385-18.059,11.385,18.059a2.913,2.913,0,0,0,2.468,1.372,2.88,2.88,0,0,0,1.583-.475m91.612,0a3.026,3.026,0,0,0,.88-4.132l-13.85-21.968a2.9,2.9,0,0,0-4.93,0l-13.85,21.968a3.026,3.026,0,0,0,.879,4.132,2.9,2.9,0,0,0,4.05-.9l11.385-18.059,11.385,18.059a2.913,2.913,0,0,0,2.468,1.372,2.879,2.879,0,0,0,1.582-.475m-44.926-.9,13.85-21.969a3.026,3.026,0,0,0-.879-4.132,2.9,2.9,0,0,0-4.05.9L169.321,160.1l-11.385-18.059a2.9,2.9,0,0,0-4.929,0L141.621,160.1l-11.385-18.059a2.9,2.9,0,0,0-4.05-.9,3.026,3.026,0,0,0-.879,4.132l13.85,21.969a2.9,2.9,0,0,0,4.93,0l11.385-18.059,11.385,18.059a2.9,2.9,0,0,0,4.93,0M92.255,140.668h-21.3a2.99,2.99,0,0,0,0,5.979h7.718v18.979a2.931,2.931,0,1,0,5.862,0V146.648h7.718a2.99,2.99,0,0,0,0-5.979",
    transform: "translate(-68.026 -130.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4465",
    "data-name": "Path 4465",
    d: "M95.643,127.091H86.691a1.393,1.393,0,0,1,0-2.785h8.952a1.393,1.393,0,1,1,0,2.785",
    transform: "translate(-79.321 -120.034)",
    fill: "#fc4c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4466",
    "data-name": "Path 4466",
    d: "M95.681,112.846a.886.886,0,0,1,.886-.886h2.9a.886.886,0,0,1,0,1.773h-2.9a.886.886,0,0,1-.886-.886",
    transform: "translate(-86.111 -111.96)",
    fill: "#fc4c02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0ac1986932280a7f2a837b2de93e5742.svg";
export { ForwardRef as ReactComponent };